export default __webpack_public_path__ + "static/media/logoBg.a53590d3.png";